import { ENTITY_URL } from "../../../config/config";
import { connection } from "../../../utils/connection";

const confirmarTurnoADP = async ({ id, token, callbacks }) => {
    const response = await connection({ method: 'POST', url: `${ENTITY_URL.ADP.TURNOS.CONFIRMAR_TURNO}${id}`, extraHeaders: { token: token } });
    if (typeof callbacks === "function") {
        callbacks(response);
    }
}

export default confirmarTurnoADP;